'use strict';

define(['app'], function (app) {

  var subscribeAndSave = function subscribeAndSave() {
    var DATA_SELECTED = 'data-selected';
    var component = {};

    component.config = {
      selectors: {
        oneTimePurchaseRadioLabel: '.subscribeAndSave_oneTimePurchase_radio_label',
        subscriptionRadioLabel: '.subscribeAndSave_subscription_radio_label',
        subscriptionContainer: '.subscribeAndSave_subscription_container',
        radio: '.subscribeAndSave_radio_wrapper'
      },
      classes: {
        subscriptionContainerShow: 'subscribeAndSave_subscription_container_show'
      },
      subscribeChannels: {
        showSubscribeAndSaveContracts: 'subscribeAndSaveContracts/show',
        subscribeAndSaveMessage: 'productPrice/changeSubscribeAndSaveMessage',
        subscribeAndSavePriceChange: 'subscribeAndSave/productPriceChange',
        subscribeAndSaveContractsChange: 'subscribeAndSave/contractsChange'
      }
    };

    component.init = function (element) {
      component.element = element;
      component.oneTimePurchaseRadioLabel = element.querySelector(component.config.selectors.oneTimePurchaseRadioLabel);
      component.subscriptionRadioLabel = element.querySelector(component.config.selectors.subscriptionRadioLabel);
      component.subscriptionContainer = element.querySelector(component.config.selectors.subscriptionContainer);
      component.radios = element.querySelectorAll(component.config.selectors.radio);
      component.bind();
      component.subscribeToChannels();
    };

    component.bind = function () {
      component.oneTimePurchaseRadioLabel.addEventListener('click', component.oneTimePurchaseRadioLabelClick);
      component.subscriptionRadioLabel.addEventListener('click', component.subscriptionRadioLabelClick);

      component.radios.forEach(function (radio) {
        return radio.addEventListener('click', function (e) {
          e.target.value === 'oneTimePurchase' ? component.oneTimePurchaseRadioLabelClick() : component.subscriptionRadioLabelClick();
        });
      });
    };

    component.oneTimePurchaseRadioLabelClick = function () {
      component.oneTimePurchaseRadioLabel.setAttribute(DATA_SELECTED, "true");
      component.subscriptionRadioLabel.setAttribute(DATA_SELECTED, "false");

      if (component.subscriptionContainer.classList.contains(component.config.classes.subscriptionContainerShow)) {
        component.subscriptionContainer.classList.remove(component.config.classes.subscriptionContainerShow);
      }

      // Arguments to publish: showOTPMessage, showSubscribeMessage
      app.publish(component.config.subscribeChannels.subscribeAndSaveMessage, true, false);
      app.publish(component.config.subscribeChannels.showSubscribeAndSaveContracts, false);
    };

    component.subscriptionRadioLabelClick = function () {
      component.oneTimePurchaseRadioLabel.setAttribute(DATA_SELECTED, "false");
      component.subscriptionRadioLabel.setAttribute(DATA_SELECTED, "true");

      if (!component.subscriptionContainer.classList.contains(component.config.classes.subscriptionContainerShow)) {
        component.subscriptionContainer.classList.add(component.config.classes.subscriptionContainerShow);
      }

      // Arguments to publish: showOTPMessage, showSubscribeMessage
      app.publish(component.config.subscribeChannels.subscribeAndSaveMessage, false, true);
      app.publish(component.config.subscribeChannels.showSubscribeAndSaveContracts, true);
    };

    component.updateProductPriceMessages = function () {
      var oneTimePurchaseAttribute = component.oneTimePurchaseRadioLabel.getAttribute(DATA_SELECTED) === 'true';
      var subscriptionAttribute = component.subscriptionRadioLabel.getAttribute(DATA_SELECTED) === 'true';
      app.publish(component.config.subscribeChannels.subscribeAndSaveMessage, oneTimePurchaseAttribute, subscriptionAttribute);
    };

    component.updateSubscribeAndSaveContractsState = function () {
      app.publish(component.config.subscribeChannels.showSubscribeAndSaveContracts, component.subscriptionRadioLabel.getAttribute(DATA_SELECTED) === 'true');
    };

    component.subscribeToChannels = function () {
      app.subscribe(component.config.subscribeChannels.subscribeAndSavePriceChange, component.updateProductPriceMessages);
      app.subscribe(component.config.subscribeChannels.subscribeAndSaveContractsChange, component.updateSubscribeAndSaveContractsState);
    };

    return component;
  };

  return subscribeAndSave;
});
//# sourceMappingURL=subscribeAndSave.js.map
